import { v4 as uuidv4 } from "uuid";

export const SPRINTS = [
  { id: uuidv4(), teamId: uuidv4(), sprintCount: 48, name: "Hello World" },
  { id: uuidv4(), teamId: uuidv4(), sprintCount: 49, name: "Happy New Year" },
];
